import { ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext } from 'react';
import ReactPlayer from 'react-player';
import BrandingService from '../../../../../services/branding.service';
import { AppContext } from '../../../../../state/app.state';

type ObjectViewVideoPlayerProps={
    showVideo: boolean;
    selectedObject: ObjectContainerClientT;
};

const ObjectViewVideoPlayer: React.FC<ObjectViewVideoPlayerProps> = ({ showVideo, selectedObject }): ReactElement => {
    const { state } = useContext(AppContext);
    const url = state?.fileCollections?.find(({ id }) => id === selectedObject.videoCollectionId)?.files[0].url?.original;

    return (
        <>{showVideo && url && <div className='bv-objectview-tour'>
            <ReactPlayer
                muted
                controls
                playsinline
                width={'calc(100% - 2rem)'}
                style={{ marginLeft: '2rem' }}
                height={'100%'}
                url={url}
            >
            </ReactPlayer>
        </div>}</>
    );
};


export default ObjectViewVideoPlayer;